import styled from 'styled-components';

export const Metric = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.metrics.margin}px 0;
`;

export const MetricTitle = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 14px;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
  overflow-wrap: break-word;
`;

export const MetricNumber = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 18px;
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./src/common/modules/printing/styles/Metric.js